import { IDriveViewTagOptions } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

export interface IUseTagOptionsResponse {
  tagOptions: IDriveViewTagOptions;
}

export function useTagOptions() {
  const { data, error, isLoading, mutate } = useSWR<IUseTagOptionsResponse>(
    'drive-view/tag-options',
    SWRFetcher({ method: 'GET' }),
  );
  return { data, error, isLoading, mutate };
}
